import { BasePlan } from './plan';
// キャンペーンコードのクエリパラメータ
export const CAMPAIGN_CODE_QUERY = 'campaign_code';
// 協業連携用認証コードのクエリパラメータ
export const COLLABORATION_CODE_QUERY = 'collaboration_code';
export const FRIEND_INVITATION_3_CODE = 'friend-invitation-cp3';
export const FIRST_YEAR_FRIEND_INVITATION_CODE = 'friend-invitation-first-year-cp';
export const FRIEND_INVITATION_CODES = [
    'friend-invitation-cp',
    'friend-invitation-cp2',
    FRIEND_INVITATION_3_CODE,
    FIRST_YEAR_FRIEND_INVITATION_CODE,
];
export const resolveSignupCampaignCode = (campaignCode) => {
    return FRIEND_INVITATION_CODES.includes(campaignCode) ? FIRST_YEAR_FRIEND_INVITATION_CODE : campaignCode;
};
export const COMMOT_YEAR_END_CODE = 'comotto2526';
export const COMMOT_TRIAL_30DAYS = 'comotto2601';
export const AMAZON_PAY_CP_CODE = 'externalpayment_202512';
export const START_FROM_MATCHING_ASSESSMENT_CP_CODE = 'questionnaire_2512';
export const REFUND_CP = 'refund-cp';
export const LIFECARD_CP_CODE = 'lifecard';
// カウントダウンタイマーを表示するキャンペーンコード
export const COUNTDOWN_ENABLED_CAMPAIGN_CODES = ['countdown_2601', REFUND_CP];
// 返金保証キャンペーンコード
export const REFUND_CP_CODES = [REFUND_CP];
export const isRefundCampaignCode = (campaignCode) => {
    return REFUND_CP_CODES.includes(campaignCode);
};
export const isLifecardCampaignCode = (campaignCode) => {
    return campaignCode === LIFECARD_CP_CODE;
};
// キャンペーンコードに関するエンティティ
export class Campaign {
    constructor(campaignData, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "campaignCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "plans", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "basePlans", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = campaignData.id;
        this.campaignCode = campaignData.campaignCode;
        this.name = campaignData.name;
        this.isActive = campaignData.isActive;
        this.basePlans = campaignData.basePlans.map((p) => new BasePlan(p, config));
    }
    get isFriendInvitation() {
        return FRIEND_INVITATION_CODES.includes(this.campaignCode);
    }
    get isFirstYearFriendInvitation() {
        return this.campaignCode === FIRST_YEAR_FRIEND_INVITATION_CODE;
    }
    get isCommotYearEndCP() {
        return this.campaignCode === COMMOT_YEAR_END_CODE;
    }
    get isCommotTrial30Days() {
        return this.campaignCode === COMMOT_TRIAL_30DAYS;
    }
    get isAmazonPayCPCP() {
        return this.campaignCode === AMAZON_PAY_CP_CODE;
    }
    get isStartFromMatchingAssessmentCpCode() {
        return this.campaignCode === START_FROM_MATCHING_ASSESSMENT_CP_CODE;
    }
    get isCountdownEnabled() {
        return COUNTDOWN_ENABLED_CAMPAIGN_CODES.includes(this.campaignCode);
    }
}
